<template>
  <div class="body__form--subscription">
    <div class="subscription__section">
      <div class="hide__subscription-section">
        <div class="card">
          <div class="card-body">
            <div class="step__voyage">
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="
                    step === 1 || step === 2 ? 'custom__badge--active' : ''
                  "
                >
                  1
                </div>
                <div
                  class="badge__text"
                  :class="
                    step === 1 || step === 2
                      ? 'badge__text--active--active'
                      : ''
                  "
                >
                  Informations
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 3 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 3 ? 'badge__text--active--active' : ''"
                >
                  Fichiers joints
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 4 ? 'custom__badge--active' : ''"
                >
                  3
                </div>
                <div
                  class="badge__text"
                  :class="step === 4 ? 'badge__text--active--active' : ''"
                >
                  Résultat
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-body">
            <div class="custom__badge-section d-md-none">
              <div
                class="custom__badge_default"
                :class="step === 1 || step === 2 ? 'custom__badge--active' : ''"
              >
                1
              </div>
              <div
                class="custom__badge_default"
                :class="step === 3 ? 'custom__badge--active' : ''"
              >
                2
              </div>
              <div
                class="custom__badge_default"
                :class="step === 4 ? 'custom__badge--active' : ''"
              >
                3
              </div>
            </div>

            <!-- debut ici -->
            <div class="row mb-2" v-if="step === 1">
              <div class="col-md-9 col-12">
                <div class="form-check">
                  <label class="form-check-label form__label">
                    <input
                      type="radio"
                      v-model="form.data.type_engin"
                      class="form-check-input"
                      value="1"
                      name="materiel"
                    />Véhicules à 4 roues
                  </label>
                  <label
                    @click="changeType()"
                    class="form-check-label ml-5 form__label"
                  >
                    <input
                      type="radio"
                      v-model="form.data.type_engin"
                      class="form-check-input"
                      value="2"
                      name="materiel"
                    />Véhicules à 2 ou 3 roues
                  </label>
                </div>
              </div>
            </div>
            <div v-if="['2', '3'].includes(node) && step === 1">
              <h4 class="mb-4">Informations clients</h4>
              <div class="form-row">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Nom du client</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_name"
                      type="text"
                      class="form-control"
                      required
                    />
                    <div v-if="errors.client_name" style="color: red">
                      {{ errors.client_name[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Prénom(s) du client</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_firstname"
                      type="text"
                      class="form-control"
                      required
                    />
                    <div v-if="errors.client_firstname" style="color: red">
                      {{ errors.client_firstname[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Numéro de téléphone</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_phone"
                      type="number"
                      min="0"
                      class="form-control"
                    />
                    <div v-if="errors.client_phone" style="color: red">
                      {{ errors.client_phone[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Email</label>
                    <input
                      v-model="form.data.client_email"
                      type="email"
                      class="form-control"
                      required
                    />
                    <div v-if="errors.client_email" style="color: red">
                      {{ errors.client_email[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin ici -->

            <h4 class="mb-4">{{ titleStep() }}</h4>
            <div v-if="step === 1">
              <div class="row">
                <div class="col-md-12 col-12" v-if="auth.profile == 2">
                  <div class="form-group">
                    <label class="form__label">Intermédiaire associé</label>
                    <select
                      v-model="form.data.sale_code"
                      class="form-control"
                      required
                      @change="getSalePoint()"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in intermediaires"
                        :key="key"
                        :value="item.sale_code"
                      >
                        {{ item.nom_entreprise ? item.nom_entreprise : item.last_name + ' ' + item.first_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Type de carburant</label>
                    <span class="required">*</span>
                    <select
                      @change="getPuissance()"
                      v-model="form.data.fuel_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in typeCarburant"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.fuel_id" style="color: red">
                      {{ errors.fuel_id[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Puissance en chevaux</label>
                    <span class="required">*</span>
                    <select v-model="form.data.power_id" class="form-control">
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in puissance"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.power_id" style="color: red">
                      {{ errors.power_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Catégorie / Usage</label>
                    <span class="required">*</span>
                    <select
                      @change="() => {
                        getSubcategory()
                        getDurations()
                      }"
                      v-model="form.data.category_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in categories"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.category_id" style="color: red">
                      {{ errors.category_id[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Sous catégorie</label>
                    <span class="required">*</span>
                    <select
                      @change="getSurprime()"
                      v-model="form.data.sub_category_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in sub_cateogries"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.sub_category_id" style="color: red">
                      {{ errors.sub_category_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div :class="`col-md-${form.data.duration_of_insurance == `6 month` && form.data.category_id == 4 ? `4` : `6`} col-12`">
                  <div class="form-group">
                    <label class="form__label">Nombre de places</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.number_of_seats_in_the_vehicle"
                      type="number"
                      min="0"
                      class="form-control"
                      required
                    />
                    <div
                      v-if="errors.number_of_seats_in_the_vehicle"
                      style="color: red"
                    >
                      {{ errors.number_of_seats_in_the_vehicle[0] }}
                    </div>
                  </div>
                </div>
                <div :class="`col-md-${form.data.duration_of_insurance == `6 month` && form.data.category_id == 4 ? `4` : `6`} col-12`">
                  <div class="form-group">
                    <label class="form__label">Durée de l’abonnement</label>
                    <span class="required">*</span>
                    <select
                      v-model="form.data.duration_of_insurance"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in durations"
                        :key="key"
                        :value="item.slug"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.duration_of_insurance" style="color: red">
                      {{ errors.duration_of_insurance[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-12" v-if="form.data.category_id == 4 && form.data.duration_of_insurance == '6 month'">
                  <div class="form-group">
                    <label class="form__label">1er 6 mois ?</label>
                    <span class="required">*</span>
                    <div class="form-check mt-2">
                      <label class="form-check-label form__label">
                        <input
                          v-model="form.data.first_six_month"
                          :value="true"
                          type="radio"
                          class="form-check-input"
                          name="owner"
                        />Oui
                      </label>
                      <label class="form-check-label form__label ml-5">
                        <input
                          v-model="form.data.first_six_month"
                          :value="false"
                          type="radio"
                          class="form-check-input"
                          name="owner"
                        />Non
                      </label>
                    </div>
                    <div
                      v-if="errors.first_six_month"
                      style="color: red"
                    >
                      {{ errors.first_six_month[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Vénale</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.valeur_venal"
                      type="number"
                      min="0"
                      class="form-control"
                      required
                    />
                    <div v-if="errors.valeur_venal" style="color: red">
                      {{ errors.valeur_venal[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Neuve</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.valeur_neuve"
                      type="number"
                      min="0"
                      class="form-control"
                      required
                    />
                    <div v-if="errors.valeur_neuve" style="color: red">
                      {{ errors.valeur_neuve[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 2">
              <div class="row" v-if="surprime.length > 0">
                <div class="col-12">
                  <h6 class="font-weight-bold">
                    Surprime responsabilité civile
                  </h6>
                </div>
              </div>
              <div class="row mb-2" v-if="form.data.category_id == 4">
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        type="checkbox"
                        :disabled="true"
                        :checked="true"
                      />
                      Surprime
                      <svg
                        style="cursor: pointer"
                        @click="showTooltips('Surprime')"
                        class="tooltips_n"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z"
                            fill="#5E5873"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z"
                            fill="#5E5873"
                          />
                          <path
                            d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z"
                            fill="#5E5873"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0.5 0.0725098)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      {{ getCategory4Surprime() }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2" v-for="(item, key) in surprime" :key="key">
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        type="checkbox"
                        @click="checkSurprime(item)"
                        :disabled="item.required ? true : false"
                        :checked="
                          item.required ||
                          (form.data.semi_remorque == true &&
                            item.text.includes('Surprimes')) ||
                          (form.data.domage == true &&
                            item.text.includes('Dommages'))
                            ? true
                            : false
                        "
                      />
                      {{ item.text === 'Surprime par place' ? 'Surprime' : item.text }}
                      <svg
                        style="cursor: pointer"
                        @click="showTooltips(item.text)"
                        class="tooltips_n"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z"
                            fill="#5E5873"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z"
                            fill="#5E5873"
                          />
                          <path
                            d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z"
                            fill="#5E5873"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0.5 0.0725098)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div
                      v-if="
                        item.required ||
                        item.text.includes('Dommages') ||
                        item.text.includes('Surprimes')
                      "
                      class="surprime__section-two"
                    ></div>
                    <div
                      v-if="
                        item.required ||
                        item.text.includes('Dommages') ||
                        item.text.includes('Surprimes')
                      "
                      class="surprime__section-tree"
                    >
                      {{ getPirce(item) }}
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div v-if="garuanted.length > 0" class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold">Garanties</h6>
                </div>
              </div>
              <div
                class="row mb-2"
                v-for="(item, key) in garuanted"
                :key="`el` + key"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        :class="'garuanted' + key"
                        type="checkbox"
                        :disabled="
                          form.data.category_id == 4 && item.id != 54 && form.data.list_of_guarantees.includes(item.id)
                            ? true
                            : false
                        "
                        :checked="
                          form.data.list_of_guarantees.includes(item.id)
                            ? true
                            : false
                        "
                        @click="checkGaruanted(item, key)"
                      />
                        {{ item.name }}
                      
                        <!-- <svg style="cursor: pointer" @click="showTooltips('')" class="tooltips_n" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z" fill="#5E5873"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z" fill="#5E5873"/>
                                <path d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z" fill="#5E5873"/>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.0725098)"/>
                                </clipPath>
                            </defs>
                        </svg> -->
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      {{
                        item.id != 18 && item.id != 30 && item.id != 42 ? $format(getPriceGaruanted(item)) : $format(getAnotherPrice(item))
                      }} Fcfa
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step === 3">
              <p>
                Veuillez charger le(s) fichier(s) requis :
                <span style="color: #d09a12">copie de la carte grise.</span>
              </p>
              <file-upload
                ref="upload"
                :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
              />
            </div>
            <div v-if="step === 4">
              <div style="max-width: 70%" class="text-sm mb-2" v-if="auth.profile === 3">
                Pour offir une réduction au client entrez, le pourcentage de réduction dans le champ ci-dessous puis validez
              </div>
              <div class="detail__sup">
                <div class="row mb-2 d-flex align-items-center" v-if="auth.profile === 3">
                  <div class="col-md-8">
                    <input 
                      type="number" 
                      min="1" 
                      class="form-control form-control-sm"
                      placeholder="Entrez le % de réduction" 
                      v-model="pourcentageReduction"
                      :disabled="alreadyReduce"
                    />
                  </div>
                  <div class="col-md-4 my-md-0 my-3">
                    <button 
                      class="btn btn-primary btn-sm" 
                      @click="applyReduce()" 
                      :disabled="alreadyReduce"
                    >
                      Appliquer la réduction
                    </button>
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Avenant</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ format(summary.avenant) }} FCFA
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Frais de dossier</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ format(summary.fees) }} FCFA
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Taxes</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ format(summary.taxe) }} FCFA
                  </div>
                </div>
                <div class="section__information">
                  <div class="section__information-text">Prime nette</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(Math.round(summary.amount)) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__amount d-flex justify-content-between">
                  <div class="section__amount-text">Total</div>
                  <div class="section__amount-price">
                    {{ $format(Math.round(summary.total)) + " Fcfa" }}
                  </div>
                </div>
              </div>
              <div class="section__neg" v-if="node == '0'" @click="saveNegotiated()">
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                    fill="#002A85"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                    fill="#002A85"
                  />
                  <path
                    d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 9.50065 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 6.73922Z"
                    fill="#002A85"
                  />
                </svg>
                <span class="section__neg-text">Demander une négociation</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="button__footer">
              <button
                @click="prevStep()"
                :disabled="step === 1"
                class="btn btn-default__cancel mr-2"
              >
                Retour
              </button>
              <button
                :class="loading ? 'disabled' : ''"
                :disabled="loading"
                class="btn btn-primary__save"
                @click="saveAssurance()"
              >
                {{ getText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance auto n° {{ id }}
            </h5>
            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api, apiV1 } from "../../../helpers/shared";
import FileUpload from "../../../components/upload/FileUpload.vue";
import { durations } from "../../../../constants/durations"
export default {
  props: ["node"],
  components: { FileUpload },
  name: "auto",
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    pourcentageReduction: '',
    auth: {},
    alreadyReduce: false,
    intermediaires: [],
    errors: [],
    step: 1,
    element: 0,
    loading: false,
    forfaits: [],
    summary: {
      amount: 0,
      avenant: 0,
      taxe: 0,
      fees: 0,
      total: 0,
    },
    categories: [],
    typeCarburant: [
      { name: "Essence", id: 1 },
      { name: "Diesel", id: 2 },
    ],
    files: [],
    puissance: [],
    sub_cateogries: [],
    durations: [],
    surprime: [],
    garuanted: [],
    settings: {
      taxe_rate: 0.06,
      frais_dossier: 2000,
      avenant_annual: 5000,
      avenant_short: 2500,
    },
    form: {
      amount: "",
      amount_before_reduce: "",
      per: "",
      product_id: 1,
      step: 1,
      data: {
        client_name: "",
        client_firstname: "",
        client_phone: "",
        client_email: "",
        type_engin: "1",
        fuel_id: "",
        power_id: "",
        sale_code: "",
        sale_point: "",
        category_id: "",
        sub_category_id: "",
        use_type: "",
        semi_remorque: false,
        domage: false,
        first_six_month: "",
        duration_of_insurance: "",
        number_of_seats_in_the_vehicle: "",
        pourcentage_reduction: '',
        originalPrc: 0,
        name: "",
        email: "",
        address: "",
        phone: "",
        valeur_venal: "",
        valeur_neuve: "",
        person_to_contact: "",
        telephone_number: "",
        vehicle_registration_card: "",
        list_of_guarantees: [],
      },
    },
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
    uuid: "",
    id: "",
  }),
  watch: {
    pourcentageReduction(newValue, oldValue) {
      if (newValue.startsWith("0") && newValue.length > 1) {
        this.pourcentageReduction = newValue.replace(/^0+/, "");
      }
    },
    'form.data.duration_of_insurance': function(newValue, oldValue) {
      this.applyLiveCalculation();
    },
    'form.data': {
      handler(newValue, oldValue) {
        if (newValue.category_id && newValue.duration_of_insurance && newValue.fuel_id && newValue.power_id) {
            this.applyLiveCalculation();
        }
      },
      deep: true
    }
  },
  mounted() {

    this.getCategorie();
    this.getDurations();
    this.getIntermediairesWithSaleCode()
    this.auth = JSON.parse(localStorage.getItem('auth')).user
  },
  methods: {
    format(value) {
      // `format()` est utilisé dans le template; on délègue au helper global `$format`.
      // (Évite l'erreur: "_vm.format is not a function")
      if (typeof this.$format === "function") {
        return this.$format(value ?? 0);
      }
      return value ?? 0;
    },
    getSalePoint() {
      const intermediaire = this.intermediaires.find(item => item.sale_code === this.form.data.sale_code)

      if(intermediaire) {
        this.form.data.sale_point = intermediaire.nom_entreprise ? intermediaire.nom_entreprise : intermediaire.last_name + ' ' + intermediaire.first_name
      }
    },

    applyLiveCalculation() {
      // Déclenche un calcul en temps réel via l'API InsurancePricingService
      // Évite les 422: ne pas appeler tant que les champs requis ne sont pas renseignés.
      if (
        !this.form?.data?.duration_of_insurance ||
        !this.form?.data?.type_engin ||
        !this.form?.data?.power_id ||
        !this.form?.data?.number_of_seats_in_the_vehicle ||
        !this.form?.data?.valeur_venal ||
        !this.form?.data?.valeur_neuve
      ) {
        return;
      }

      // Auto (type_engin = 1) requiert aussi fuel/category/sub_category
      if (String(this.form.data.type_engin) === "1") {
        if (!this.form.data.category_id || !this.form.data.sub_category_id || !this.form.data.fuel_id) {
          return;
        }
      }

      axios
        .post(apiV1("subscriptions/auto-calculate"), {
          product_id: 1, // Auto
          type_engin: this.form.data.type_engin,
          category_id: this.form.data.category_id,
          sub_category_id: this.form.data.sub_category_id,
          duration_of_insurance: this.form.data.duration_of_insurance,
          fuel_id: this.form.data.fuel_id,
          power_id: this.form.data.power_id,
          number_of_seats_in_the_vehicle: this.form.data.number_of_seats_in_the_vehicle,
          valeur_venal: this.form.data.valeur_venal,
          valeur_neuve: this.form.data.valeur_neuve,
          list_of_guarantees: this.form.data.list_of_guarantees,
          is_owner: this.form.data.is_owner,
          pourcentage_reduction: this.form.data.pourcentage_reduction || null,
        })
        .then((response) => {
          if (response.data.status) {
            this.summary.amount = response.data.net_premium;
            this.summary.avenant = response.data.avenant;
            this.summary.taxe = response.data.tax;
            this.summary.fees = response.data.fees || 0;
            this.summary.total = response.data.total;
          }
        })
        .catch((error) => {
          console.error("Live calculation failed:", error);
        });
    },
    getIntermediairesWithSaleCode() {
      axios
        .get(api("intermediaires"))
        .then((response) => {
          this.intermediaires = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategory4Surprime() {
      if(!this.form.data.prc) return
      
      if(this.form.data.sub_category_id == 21) {
        return Math.round(this.form.data.prc * 0.35 * (this.form.data.number_of_seats_in_the_vehicle - 1))
      }

      if(this.form.data.sub_category_id == 22) {
        if(this.form.data.number_of_seats_in_the_vehicle >= 10 && this.form.data.number_of_seats_in_the_vehicle <= 15) {
          return 96300
        }

        if(this.form.data.number_of_seats_in_the_vehicle >= 16 && this.form.data.number_of_seats_in_the_vehicle <= 20) {
          return 102720
        }

        if(this.form.data.number_of_seats_in_the_vehicle > 20) {
          return Math.round(102720 + (this.form.data.number_of_seats_in_the_vehicle - 20) * 3900)
        }
      }
    },
    applyReduce() {
      if(this.pourcentageReduction) {
        if(this.pourcentageReduction === 0 || this.pourcentageReduction === '0') {
          this.$toasted.global.error({
            message: "Entrez une valeur suppérieur à 0",
          })
          return
        }

        this.form.data.pourcentage_reduction = this.pourcentageReduction;
        this.applyLiveCalculation();
        this.alreadyReduce = true;

        this.$toasted.global.all({
          message: "la réduction a été appliquée et le prix recalculé par le serveur",
        });
      } else {
        this.$toasted.global.error({
          message: "Entrez une valeur avant de valider",
        })
      }
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.uuid;
        this.comment.id = this.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    closeModal() {
      this.$document("#comments").modal("hide");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    showComments() {
      db.collection(this.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    checkSurprime(item) {
      if (item.text.includes("Surprimes")) {
        this.form.data.semi_remorque = !this.form.data.semi_remorque;
      }
      if (item.text.includes("Dommages")) {
        this.form.data.domage = !this.form.data.domage;
      }
    },
    getSurprime() {
      if (this.form.data.sub_category_id != "") {
        let element = this.sub_cateogries.find(
          (el) => el.id == this.form.data.sub_category_id
        );
        if (element) {
          this.surprime = element.surprime ? element.surprime : [];
        } else this.surprime = [];
      } else this.surprime = [];
    },
    showTooltips(text) {
      this.$document(".tooltips_n").tooltip({
        title: text,
        trigger: "click",
        placement: "top",
      });
    },
    getPirce(item) {
      const price = item.coast
      if (price == "") {
        if (
          ["12", "13", "14", "15"].includes(
            this.form.data.number_of_seats_in_the_vehicle
          )
        ) {
          return this.$format(96300);
        }
        if (
          ["16", "17", "18", "19", "20"].includes(
            this.form.data.number_of_seats_in_the_vehicle
          )
        ) {
          return this.$format(102720);
        }
        if (this.form.data.number_of_seats_in_the_vehicle > 20) {
          return this.$format(
            102720 +
              parseInt(this.form.data.number_of_seats_in_the_vehicle - 20) *
                3900
          );
        }
      } else {
        if(item.text == 'Surprime par place') {
          const placePrime = price * (this.form.data.number_of_seats_in_the_vehicle - 1)

          if(this.form.data.category_id != 4) {
            const durations = require("../../../../../app/Helpers/duration.json");
            const durationItem = durations.find(
              d => d.slug === this.form.data.duration_of_insurance
            )
  
            // Pour éviter les erreurs si non trouvé
            if (!durationItem) {
              throw new Error('Duration not found')
            }
  
            // Calcul du pourcentage
            const durationPercentage = durationItem.percentage / 100
  
            // Condition
            if (durationItem.id < 8) {
              return this.$format(Math.round(placePrime * durationPercentage));
            }
  
            if(durationItem.id >= 8 && durationItem.id <= 11 || durationItem.id > 11) {
              const now = new Date()
  
              // Parse "1 year", "6 months", "30 days"
              const targetDate = this.addDuration(now, durationItem.slug)
  
              // Différence en jours (équivalent diffInDays)
              let daysDiff = Math.floor(
                (targetDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
              )
  
              daysDiff -= 1
  
              const isTruth = durationItem.slug !== '1 year' && daysDiff < 365
  
              if(isTruth) {
                return this.$format(Math.round((placePrime * daysDiff) / 365))
              }
            }
          }

          return this.$format(placePrime);
        } else {
          if((item.id == 19 || item.id == 20) && item.text == 'Surprimes remorques ou semi-remorques') {
            return this.$format(0.25 * this.form.data.prc)
          }
          // Si c'est un forfait (Vol accessoires, etc.), utiliser directement le montant de la DB
          return this.$format(price)
        }
      }
    },
    addDuration(date, slug) {
      const [valueStr, unit] = slug.split(' ')
      const value = Number(valueStr)

      const result = new Date(date)

      switch (unit) {
        case 'day':
        case 'days':
          result.setDate(result.getDate() + value)
          break

        case 'month':
        case 'months':
          result.setMonth(result.getMonth() + value)
          break

        case 'year':
        case 'years':
          result.setFullYear(result.getFullYear() + value)
          break

        default:
          throw new Error(`Unsupported duration: ${slug}`)
      }

      return result
    },
    getDaysDiffFromSlug(slug) {
      const now = new Date();

      // Créer une nouvelle date à partir de now
      const targetDate = new Date(now);

      // Découper le slug en nombre + unité
      const [amountStr, unit] = slug.split(' ');
      const amount = parseInt(amountStr);

      // Ajouter à targetDate selon l'unité
      switch (unit) {
        case 'day':
        case 'days':
          targetDate.setDate(targetDate.getDate() + amount);
          break;
        case 'month':
        case 'months':
          targetDate.setMonth(targetDate.getMonth() + amount);
          break;
        case 'year':
        case 'years':
          targetDate.setFullYear(targetDate.getFullYear() + amount);
          break;
        default:
          throw new Error('Unité de durée non supportée : ' + unit);
      }

      // Calcul de la différence en jours
      const diffInMs = targetDate - now;
      const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

      return diffInDays;
    },
    getPriceGaruanted(item) {
      const ids = []

      if(this.form.data.category_id == 4) {
        let diffInDays = this.getDaysDiffFromSlug(this.form.data.duration_of_insurance)

        diffInDays -= 1

        let price
        
        if(item.id == 54) return 0
        
        if(item.id == 55) {
          if(this.form.data.number_of_seats_in_the_vehicle <= 9 && this.form.data.number_of_seats_in_the_vehicle >= 5) {
            price = Math.round(this.form.data.valeur_venal * 0.01)
          }

          if(this.form.data.number_of_seats_in_the_vehicle >= 10) {
            price = Math.round(this.form.data.valeur_venal * 0.015)
          }

          if(this.form.data.duration_of_insurance == '6 month') {
            if(this.form.data.first_six_month == true) {
              price = Math.round(price * 0.6)

            } else {
              price = Math.round(price * 0.45)
            }
          }

          return price
        }
        
        if(item.id == 56) {
          price = Math.round(this.form.data.valeur_venal * 0.0035)

          if(this.form.data.duration_of_insurance == '6 month') {
            if(this.form.data.first_six_month == true) {
              price = Math.round(price * 0.6)

            } else {
              price = Math.round(price * 0.45)
            }
          }

          return price
        }
        
        if(item.id == 57) {
          price = 10000

          if(this.form.data.duration_of_insurance == '6 month') {
            if(this.form.data.first_six_month == true) {
              price = Math.round(price * 0.6)

            } else {
              price = Math.round(price * 0.45)
            }
          }

          return price
        }
      }

      if(!ids.includes(item.id)) return this.$format(Math.round(item.amount))

      if(this.form.data.category_id == 1 || this.form.data.category_id == 2 || this.form.data.category_id == 3 || this.form.data.category_id == 5) {
        if(this.form.data.duration_of_insurance == '1 year') {
          if(item.id == 19) return Math.round(this.form.data.valeur_venal * 0.008)
  
          if(item.id == 20) return Math.round(this.form.data.valeur_venal * 0.0035)
  
          if(item.id == 21) return Math.round(this.form.data.valeur_venal * 0.02)
  
          if(item.id == 22) return 10000
  
          if(item.id == 24) return !this.form.data.list_of_guarantees.includes(25) || !this.form.data.list_of_guarantees.includes(36) || !this.form.data.list_of_guarantees.includes(47) ? Math.round(this.form.data.valeur_neuve * 0.01) : 0
          
          if(item.id == 25) return Math.round(this.form.data.valeur_neuve * 0.0245)

          if(item.id == 53) return Math.round(this.form.data.valeur_venal * 0.0035 * 0.05)

          if(item.id == 54) return Math.round(this.form.data.valeur_neuve * 0.0245)
        }
      }

    },
    getAnotherPrice(item) {
      if(item.id == 18 || item.id == 30 || item.id == 42) {
        if(this.form.data.duration_of_insurance == '1 year') {
          return 5000
        }
        
        const durationItem = durations.find(
          d => d.slug === this.form.data.duration_of_insurance
        )

        // Pour éviter les erreurs si non trouvé
        if (!durationItem) {
          throw new Error('Duration not found')
        }

        // Calcul du pourcentage
        const durationPercentage = durationItem.percentage / 100

        // Condition
        if (durationItem.id < 8) {
          return Math.round(5000 * durationPercentage);
        }

        if(durationItem.id >= 8 && durationItem.id <= 11 || durationItem.id > 11) {
          const now = new Date()

          // Parse "1 year", "6 months", "30 days"
          const targetDate = this.addDuration(now, durationItem.slug)

          // Différence en jours (équivalent diffInDays)
          let daysDiff = Math.floor(
            (targetDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
          )

          daysDiff -= 1

          const isTruth = durationItem.slug !== '1 year' && daysDiff < 365

          if(isTruth) {
            return Math.round((5000 * daysDiff) / 365)
          }
        }
      }
    },
    saveForLate() {
      if (this.loading) return;
      if (this.step == "1") {
        this.$toasted.global.error({
          message: "Vous devez completer la première étape",
        });
      } else {
        this.loading = true;
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/save-for-late"), this.form)
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La souscription a été enrégistré",
              });
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },

    saveNegotiated() {
      if (this.step === 4) {
        let loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/negotiated"), this.form)
          .then((response) => {
            if (response.data.status) {
              let content = response.data;
              this.uuid = content.uuid;
              this.id = content.id;
              this.showComments();
              setTimeout(() => {
                this.$document("#comments").modal("show");
                loader.hide();
              }, 400);
            } else {
              loader.hide();
              this.$toasted.global.error();
            }
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    addBasket() {
      //let carts = localStorage.getItem('carts');
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                this.form.amount = this.summary.total;
                data.push({
                  product: this.form,
                  detail: this.summary,
                  files: this.files,
                  check: true,
                  uuids: this.$uuid(),
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });

                setTimeout(() => {
                  this.$router("/pannier")
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    files: this.files,
                    check: true,
                    uuids: this.$uuid(),
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });

                setTimeout(() => {
                  this.$router("/pannier")
                }, 500);
              }
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            this.$toasted.global.error({
              message: "le fichier choisi est trop volumineux",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          this.form.amount = this.summary.total;
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });

          setTimeout(() => {
            this.$router("/pannier")
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });

          setTimeout(() => {
            this.$router("/pannier")
          }, 500);
        }
      }
    },
    saveAssurance() {
      if (this.loading) return;
      if (this.step === 4) {
        this.addBasket();
      } else {
        if (this.step === 1 || this.step === 2) {
          const loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.loading = true;
          axios
            .post(api("assurances/automobile/save"), this.form)
            .then((res) => {
              this.loading = false;
              if (res.data.status) {
                this.errors = [];
                // Utiliser la structure unifiée du service centralisé
                this.summary.amount = res.data.amount.net_premium || 0;
                this.summary.taxe = res.data.amount.tax || 0;
                this.summary.avenant = res.data.amount.avenant || 0;
                this.summary.total = res.data.amount.total || 0;
                this.form.amount = res.data.amount.total || 0;

                if (this.step === 1 && res.data.amount.prc)
                  this.form.data.prc = res.data.amount.prc;

                if (this.surprime.length > 0 || this.garuanted.length > 0) {
                  this.nextStep();
                } else {
                  this.step = 3;
                }
              } else {
                this.$toasted.global.error();
              }
              loader.hide();
            })
            .catch((error) => {
              if (error && error.response && error.response.status === 422) {
                this.errors = error.response.data.errors;
                if (typeof this.errors !== "object") {
                  this.$toasted.global.error({
                    message: this.errors,
                  });
                }
              }
              this.loading = false;
              loader.hide();
            });
        } else {
          this.nextStep();
        }
      }
    },
    nextStep() {
      if (this.step < 4) this.step++;
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      if (this.step == 2 && this.form.data.category_id != 4) {
        this.form.data.list_of_guarantees = [];
      }
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
      if (this.surprime.length > 0 || this.garuanted.length > 0) {
        if (this.step == 1) {
          this.garuanted = [];
        }
        if (this.step !== 1) this.step--;
      } else {
        if (this.step === 3) {
          this.step = 1;
        }
      }
    },
    titleStep() {
      if (this.step === 1) {
        return "Informations (Étape 1/2)";
      } else if (this.step === 2) {
        return "Informations (Étape 2/2)";
      } else if (this.step === 3) {
        return "Fichiers joints";
      } else return "Résultat";
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
        case 2:
          return "Suivant";
        case 3:
          return "Suivant";
        case 4:
          return "Ajouter au panier";
      }
    },
    syncGuarantees(list) {
      const pairs = [
        [19, 20],
        [24, 25],
      ];

      pairs.forEach(([a, b]) => {
        // Si a est présent et b pas encore → on ajoute b
        if (list.includes(a) && !list.includes(b)) {
          list.push(b);
        }
        // Si b est présent et a pas encore → on ajoute a
        if (list.includes(b) && !list.includes(a)) {
          list.push(a);
        }
      });

      return list;
    },
    checkGaruanted(item, key) {
      // this.form.data.list_of_guarantees = this.syncGuarantees(this.form.data.list_of_guarantees);
      if (this.form.data.list_of_guarantees.includes(item.id)) {
        let index = this.form.data.list_of_guarantees.indexOf(item.id);
        this.form.data.list_of_guarantees.splice(index, 1);
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(this.form.data.list_of_guarantees.includes(24)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 24)
          }
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(25)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 25)
          }
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(20)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 20)
          }
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(19)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 19)
          }
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(32)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 32)
          }
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(31)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 31)
          }
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(44)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 44)
          }
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
          if(this.form.data.list_of_guarantees.includes(43)) {
            this.form.data.list_of_guarantees = this.form.data.list_of_guarantees.filter(i => i !== 43)
          }
        }
      } else {
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(24)) {
            this.form.data.list_of_guarantees.push(24)
          }
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(36)) {
            this.form.data.list_of_guarantees.push(36)
          }
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(47)) {
            this.form.data.list_of_guarantees.push(47)
          }
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(20)) {
            this.form.data.list_of_guarantees.push(20)
          }
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(19)) {
            this.form.data.list_of_guarantees.push(19)
          }
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(32)) {
            this.form.data.list_of_guarantees.push(32)
          }
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(31)) {
            this.form.data.list_of_guarantees.push(31)
          }
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(44)) {
            this.form.data.list_of_guarantees.push(44)
          }
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
          if(!this.form.data.list_of_guarantees.includes(43)) {
            this.form.data.list_of_guarantees.push(43)
          }
        }
        this.form.data.list_of_guarantees.push(item.id);
      }
    },
    getPuissance() {
      if (this.form.data.fuel_id !== "") {
        this.loading = true;
        this.zone_section = [];
        axios
          .post(api("assurance-automobile/subscription"), {
            slug: "auto",
            fuel: this.form.data.fuel_id,
            state: "power",
          })
          .then((response) => {
            this.loading = false;
            this.puissance = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    getCategorie() {
      axios
        .post(api("assurance-automobile/subscription"), {
          type: this.form.data.type_engin,
          state: "category",
        })
        .then((response) => {
          this.loading = false;
          this.categories = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getGaruanted() {
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "garuanted",
        })
        .then((response) => {
          this.loading = false;
          this.garuanted = response.data;

          if(this.form.data.category_id == 4) {
            this.form.data.list_of_guarantees.push(53,55,56,57)
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getSubcategory() {
      this.loading = true;
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "sub_category",
        })
        .then((response) => {
          this.loading = false;
          this.form.data.sub_category_id = "";
          this.sub_cateogries = response.data;
          this.getGaruanted();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    getDurations() {
      axios
        .post(api("assurance-automobile/subscription"), {
          state: "duration",
          categoryId: this.form.data.category_id,
        })
        .then((response) => {
          this.loading = false;
          this.durations = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    changeType(val) {
      this.$emit("changeType", 2);
    },
  },
};
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  transform: scale(1.2);
}

.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 150px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
    align-self: center;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}

.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg {
  cursor: pointer;
}

.section__neg-text {
  color: #002a85;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .surprime__section{
        display: grid;
        grid-template-columns: 110px 2fr 110px;
        align-items: baseline;
        .surprime__section-two{
            border-bottom: 1px dotted #000000;
        }
        .surprime__section-tree{
            justify-self: end;
            color: #000000;
            font-weight: bold;
        }
        .surprime__section-first{
            color: #6E6B7B;
        }
    }*/
.surprime__section {
  display: flex;
  flex-direction: row;
}
.surprime__section-two {
  flex-grow: 2;
  border-bottom: 1px solid;
}
.surprime__section-tree {
  flex-grow: 0;
}
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.btn-primary {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:hover {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}
.required {
  color: red;
}
</style>
